import ADPUsrService from "../../../services/admin/ADPUsrService";


class profileService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async getUserById(userId: string): Promise<any> {
        return await ADPUsrService.getItemById(userId);
    }

    async uploadImage(user: any): Promise<any> {
        return await ADPUsrService.uploadImage(user);
    }

    async update(item: any): Promise<any> {
        return await ADPUsrService.update(item.userId, item);
    }

    async checkPassword(userId: any, currentPassword: any, newPassword: any): Promise<any> {
        return await ADPUsrService.checkPassword(userId, currentPassword, newPassword);
    }


}

export default new profileService();